import React from 'react';
export function Guarantee() {
  return <section className="py-4 md:py-10 px-4 md:px-12 relative z-10" aria-label="Garantía de 7 días" data-id="element-85">
      <div className="max-w-[500px] mx-auto" data-id="element-86">
        <div className="flex items-center gap-4 md:gap-5 bg-[rgba(255,215,0,0.03)] border border-[rgba(255,215,0,0.1)] rounded-xl p-4 md:p-6" data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/wMbT3DHgUMRSxBUynxTbvF/Selo-de-Garantia-de-7-Dias-PNG-Transparente-Sem-Fundo-1.png" alt="Sello de Garantía de 7 Días" className="w-[60px] md:w-[80px] shrink-0 drop-shadow-[0_0_12px_rgba(255,215,0,0.2)]" data-id="element-88" />
          <div data-id="element-89">
            <h3 className="font-display text-[1rem] md:text-[1.2rem] tracking-[2px] text-gold mb-1" data-id="element-90">
              GARANTÍA 7 DÍAS
            </h3>
            <p className="font-text text-[0.72rem] md:text-[0.82rem] text-text-muted leading-[1.5]" data-id="element-91">
              Explora todo el contenido y comprueba el valor del sistema por ti
              mismo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}